import { api } from "./api";

export const GetMarketingSchool = async (addUrl = "") => {
  let url = `/marketing/source?${addUrl}`;
  return await api.get(url);
};
export const GetMarketingSource = async (addUrl = "") => {
  let url = `/calling/marketing/source?${addUrl}`;
  return await api.get(url);
};

export const GetMarketingData = async (addUrl = "") => {
  let url = `/calling/list?${addUrl}`;
  return await api.get(url);
};

export const GetSingleData = async (addUrl) => {
  let url = `/marketing/source/single/data?${addUrl}`;
  return await api.get(url);
};
export const CreateMarketingSchool = async (data) => {
  return await api.post(`/marketing/source/post`, data);
};

export const AssignData = async (data) => {
  return await api.post(`/calling/assign/post`, data);
};

export const UpMarketingSchool = async (data) => {
  return await api.post(`marketing/source/update`, data);
};

export const MarketingSchoolDelete = async (id) => {
  return await api.get(`marketing/source/delete?id=${id}`);
};

export const CreateMarketingStudent = async (data) => {
  return await api.post(`/marketing/student/post`, data);
};
export const CreateMarketingFollowStudent = async (data) => {
  return await api.post(`/calling/student/add/with-response`, data);
};

export const MarketingStudentList = async (addUrl = "") => {
  let url = `/marketing/students/list?${addUrl}`;
  return await api.get(url);
};

export const UpMarketingStudent = async (data) => {
  return await api.post(`/marketing/student/update`, data);
};

export const excelimport = async (data) => {
  return await api.post(`/marketing/student/post`, data);
};

export const DeleteMarketingStudent = async (id) => {
  return await api.get(`/marketing/student/delete?id=${id}`);
};

export const CallingData = async (addUrl = "") => {
  let url = `/calling/counselor/data/list?${addUrl}`;
  return await api.get(url);
};

export const followupDataPost = async (data) => {
  return await api.post(`/calling/counselor/response/post`, data);
};

export const MarketingStudentImport = async (data) => {
  return await api.post(`/marketing/student/excel/import`, data);
};
